export default [
  {
    path: '/stock-request',
    name: 'list-stock-request',
    component: () => import('@/views/stockRequest/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.stockRequest',
      resource: 'stock-request',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listStockRequest',
          active: true,
        },
      ],
    },
  },
]
